import { createApiRef } from '@backstage/core-plugin-api';
import { ConfigurationApi } from './ConfigurationApi';

/**
 * The API reference for the ConfigurationApi.
 * @public
 */
export const configurationApiRef = createApiRef<ConfigurationApi>({
  id: 'plugin.wb-configuration',
});
